import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PickUpTimeComponent from '../components/PickUpTime/PickUpTime';
import {connect} from 'react-redux';
import * as pickUpTimeActions from '../actions/pickUpTimeActions';
import {bindActionCreators} from 'redux';
import * as restaurantActions from '../actions/restaurantActions';
import {translate} from 'react-i18next';
import * as _ from 'lodash';

class PickUpTimeLayout extends Component {
  constructor(props) {
    super(props);
    this.changeTime = this.changeTime.bind(this);
    this.state = {}
  }

  static getDerivedStateFromProps(props) {
    if (_.isNull(props.availableTimes)) {
      props.checkRestaurantIsClosed(props.restaurant.id, props.t);
    }
    return {};
  }

  componentDidUpdate(prevProps) {
    if (_.difference(prevProps.availableTimes, this.props.availableTimes, 'value').length > 0 && this.props.availableTimes.length > 0) {
      this.changeTime(this.props.availableTimes[0]);
    }
  }

  changeTime(selectedOption) {
    const {restaurant, t, checkRestaurantIsClosed, changeTime, onChangeTime} = this.props;
    return checkRestaurantIsClosed(restaurant.id, t).then(() => {
      changeTime(selectedOption);
      if (onChangeTime) {
        onChangeTime(selectedOption);
      }
    });
  }

  render() {
    const {classNames, restaurant, selectedTime, availableTimes} = this.props;
    if (_.isEmpty(restaurant)) {
      return '';
    }

    return (
      <PickUpTimeComponent
        classNames={classNames}
        timeData={availableTimes}
        selectedTime={selectedTime}
        changeTime={this.changeTime}
      />
    );
  }
}

PickUpTimeLayout.propTypes = {
  classNames: PropTypes.string,
  onChangeTime: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    restaurant: state.restaurants.item,
    selectedTime: state.pickUpTime.selectedOption,
    availableTimes: state.pickUpTime.availableTimes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeTime: bindActionCreators(pickUpTimeActions.changeTime, dispatch),
    checkRestaurantIsClosed: bindActionCreators(restaurantActions.checkRestaurantIsClosedNow,
        dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
    translate('translations')(PickUpTimeLayout));


// WEBPACK FOOTER //
// ./src/containers/PickUpTime.js